import React, { useContext, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { Context } from '../../../Context';

export default function DialogPdf({ blobUrl }) {
    const { setShowPdf, setPdf, showPdf } = useContext(Context);
    const { t } = useTranslation()
    useEffect(() => {
        setPdf(blobUrl)
    }, [blobUrl])
    return (
        <div className='modal-pdf' >
            {!showPdf && (
                <span>
                    <button
                        className="button-dialog-edit-expiration-date-green"
                        style={{ width: '100%', color: '#005da1', borderRadius: 10, marginBottom: '10px' }}
                        onClick={() => setShowPdf(!showPdf)}
                    >{t('signatureRequestDetailAction2.seePdf')}</button>
                </span>)}
        </div>
    )
}
